import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "../../api/axios";
import alertify from "alertifyjs";

export default function useAuth() {
  const queryClient = useQueryClient();
  // 🔐 Check auth state (profile)
  const { data: user, isLoading: authLoading } = useQuery({
    queryKey: ["authUser"],
    queryFn: async () => {
      const res = await api.get("profile/"); // your Django session-based profile route
      return res.data;
    },
    retry: false, // don't retry if unauthenticated
  });

  // 🔑 Login Mutation
  const loginMutation = useMutation({
    mutationFn: async ({ username, password }) => {
      const res = await api.post(
        "/accounts/login/",
        { username, password },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return res.data;
    },
    onSuccess: () => {
      window.location.reload()
    },
    onError: (e) => {
      console.log("e", e.response.data.detail);
      alertify.set("notifier", "position", "top-right");
      alertify.error(e.response.data.detail);
    },
  });

  // 🔓 Logout Mutation
  const logoutMutation = useMutation({
    mutationFn: async () => {
      const res = await api.post("logout/"); // assumes you have logout endpoint
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["authUser"]); // clear cached user
    },
  });

  return {
    user,
    authLoading,
    isAuthenticated: !!user,
    login: loginMutation.mutate,
    loginLoading: loginMutation.isLoading,
    logout: logoutMutation.mutate,
    logoutLoading: logoutMutation.isLoading,
  };
}
